export const translation = {
  // Navigation
  nav_home: 'Home',
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_guides: 'Guides',
  nav_review: 'Review',
  nav_shipping: 'Shipping',
  nav_warehouse: 'Warehouse',
  nav_coupon: 'Coupon',
  nav_legit: 'Is It Legit?',
  nav_categories: 'Categories',
  nav_contact: 'Contact',
  nav_about: 'About',
  nav_buying_guide: 'Buying Guide',

  // Language Switcher
  lang_pt: 'Português',
  lang_de: 'Deutsch',
  lang_en: 'English',

  // Hero
  hero_title: 'CSSBuy Spreadsheet: Find Products, Deals & Guides in One Place',
  hero_subtitle: 'Explore the CSSBuy Spreadsheet with organized resources, buying guides, popular categories, QC information, shipping tips and updated content to help you research products with more confidence.',
  hero_cta_primary: 'Explore the CSSBuy Spreadsheet',
  hero_cta_secondary: 'Start with the Beginner Guide',
  hero_trust: 'Independent information • Practical guides • Organized content',

  // Trust Cards
  trust_spreadsheet_title: 'CSSBuy Spreadsheet',
  trust_spreadsheet_desc: 'Find organized CSSBuy Spreadsheet resources by category and search intent.',
  trust_guides_title: 'Practical Guides',
  trust_guides_desc: 'Learn about products, QC, storage, shipping and research.',
  trust_safety_title: 'Safety First',
  trust_safety_desc: 'Understand costs, external links, QC and important points before buying.',

  // Spreadsheet Intro
  spreadsheet_intro_h2: 'What is the CSSBuy Spreadsheet?',
  spreadsheet_intro_text: 'The CSSBuy Spreadsheet can be used as a starting point for researching products and finding resources related to the buying process. We have gathered guides, categories and useful information to make your research simpler and more organized.',
  spreadsheet_intro_cta: 'View the Complete CSSBuy Spreadsheet Guide',

  // Categories
  categories_h2: 'Explore the CSSBuy Spreadsheet by Category',
  categories_cta: 'View All Categories',
  cat_shoes: 'Shoes',
  cat_hoodies: 'Hoodies/Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jackets',
  cat_pants: 'Pants/Shorts',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear/Underpants',
  cat_jersey: 'Jersey',
  cat_accessories: 'Accessories',
  cat_bags: 'Bags',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',
  categories_view_all: 'View All',

  // How It Works
  how_h2: 'How to Use the CSSBuy Spreadsheet',
  how_step1: 'Choose a category',
  how_step2: 'Research products',
  how_step3: 'Check information and links',
  how_step4: 'Consult QC when available',
  how_step5: 'Compare costs and options',
  how_step6: 'Confirm current conditions before buying',

  // Popular Guides
  guides_h2: 'Most Popular CSSBuy Guides',
  guides_cta: 'View All Guides',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_coupon: 'CSSBuy Coupon',
  guide_discount: 'CSSBuy Discount Code',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_legit: 'Is CSSBuy Legit?',
  guide_qc: 'CSSBuy QC Guide',
  guide_beginner: 'CSSBuy Beginner Guide',

  // Pillar Articles
  pillar_h2: 'CSSBuy Pillar Articles',
  pillar_subtitle: 'In-depth guides to help with your product research',
  pillar_read: 'Read Article',

  // Comparison
  comparison_h2: 'Compare Before Buying',
  comparison_factor: 'Factor',
  comparison_check: 'What to check',
  comparison_product: 'Product',
  comparison_product_info: 'Current information',
  comparison_price: 'Price',
  comparison_price_info: 'Current value',
  comparison_weight: 'Weight',
  comparison_weight_info: 'Estimated/actual weight',
  comparison_shipping: 'Shipping',
  comparison_shipping_info: 'Destination and method',
  comparison_qc: 'QC',
  comparison_qc_info: 'Available photos/information',
  comparison_link: 'Link',
  comparison_link_info: 'Functionality and origin',
  comparison_policy: 'Policy',
  comparison_policy_info: 'Current rules',

  // Safety
  safety_h2: 'Safety & Important Information',
  safety_text: 'This website is an independent resource. Information about products, sellers, QC, prices, shipping, coupons and availability may change. Always verify current data before placing an order or payment.',
  safety_cta: 'Read the Safety Guide',

  // FAQ
  faq_h2: 'Frequently Asked Questions',
  faq_q1: 'What is CSSBuy Spreadsheet?',
  faq_a1: 'The CSSBuy Spreadsheet is an organized resource that brings together product categories, guides and information to help with shopping research.',
  faq_q2: 'How to use CSSBuy Spreadsheet?',
  faq_a2: 'Choose a category, research products, check links and information, consult QC and compare costs before buying.',
  faq_q3: 'Is CSSBuy Spreadsheet free?',
  faq_a3: 'Yes, the CSSBuy Spreadsheet is a free resource for product research.',
  faq_q4: 'How to verify links?',
  faq_a4: 'Always verify that links are working and from a trustworthy source before making any payment.',
  faq_q5: 'What are QC photos?',
  faq_a5: 'QC photos are quality control images taken at the warehouse to verify the actual condition of the product before shipping.',
  faq_q6: 'How does shipping work?',
  faq_a6: 'Shipping depends on the destination, package weight, chosen method and customs rules of the country.',
  faq_q7: 'How much does shipping cost?',
  faq_a7: 'Shipping costs vary depending on weight, destination and shipping method. Check our shipping guide for more details.',
  faq_q8: 'Is CSSBuy trustworthy?',
  faq_a8: 'Trustworthiness depends on multiple factors. Always verify updated information before buying.',
  faq_q9: 'Is CSSBuy legit?',
  faq_a9: 'Check our full legitimacy guide to understand what points to verify.',
  faq_q10: 'What should I check before buying?',
  faq_a10: 'Check product information, price, weight, shipping options, QC photos and current policies before any purchase.',

  // Final CTA
  final_cta_h2: 'Ready to explore the CSSBuy Spreadsheet?',
  final_cta_text: 'Start with the most popular resources and find the right guide for your research.',
  final_cta_primary: 'Explore CSSBuy Spreadsheet',
  final_cta_secondary: 'Visit Main Website',

  // Footer
  footer_resources: 'Resources',
  footer_information: 'Information',
  footer_legal: 'Legal',
  footer_languages: 'Languages',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_guides: 'Guides',
  footer_reviews: 'Reviews',
  footer_shipping: 'Shipping',
  footer_qc: 'QC',
  footer_warehouse_footer: 'Warehouse',
  footer_safety_footer: 'Safety',
  footer_faq: 'FAQ',
  footer_about: 'About',
  footer_editorial: 'Editorial Policy',
  footer_methodology: 'Methodology',
  footer_contact_footer: 'Contact',
  footer_disclaimer: 'Disclaimer',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
  footer_disclaimer_text: 'This website is an independent resource and does not officially represent CSSBuy. Information may change. Always verify before buying.',

  // Buttons
  btn_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  btn_buy_it_now: 'Buy It Now',
  btn_read_more: 'Read More',
  btn_learn_more: 'Learn More',
  btn_visit_site: 'Visit Main Website',
  btn_explore: 'Explore',

  // Article
  article_published: 'Published',
  article_updated: 'Updated',
  article_author: 'Author',
  article_related: 'Related Articles',
  article_toc: 'Contents',
  article_quick_answer: 'Quick Answer',
  article_introduction: 'Introduction',
  article_step_by_step: 'Step by Step',
  article_comparison: 'Comparison',
  article_mistakes: 'Common Mistakes',
  article_safety: 'Safety',
  article_cta: 'Continue Exploring',

  // Breadcrumb
  breadcrumb_home: 'Home',
  breadcrumb_spreadsheet: 'CSSBuy Spreadsheet',

  // Meta
  meta_title: 'CSSBuy Spreadsheet: Guides, Categories & Resources | CSSBuyBR',
  meta_description: 'Explore the CSSBuy Spreadsheet with buying guides, product categories, shipping tips and QC information. Independent resource for product research.',
  meta_keywords: 'cssbuy spreadsheet, cssbuy guide, cssbuy categories, cssbuy shipping, cssbuy review',

  // Dropdown
  dropdown_all_categories: 'All Categories',
  dropdown_select: 'Select Category',

  // Safety Notice
  safety_notice: 'This website is an independent resource and does not officially represent CSSBuy. Information about prices, products, sellers, QC, shipping, coupons and availability may change. Always verify current data before placing any order or payment.',
};

export default translation;